import Head from './../components/Head';
import MaterialCard from './components/materialCard.vue';
import Footer from '../components/Footer.vue';
import { Empty } from 'zhs-components';
export default {
  created() {
    this.getMaterialSetting();
    this.getMaterialList();
  },

  components: {
    Head,
    MaterialCard,
    Footer,
    Empty
  },

  data() {
    return {
      menuInfo: {},
      menuId: this.$utils.getUrlParams('menuId'),
      pageInfo: {
        rows: 0,
        pageIndex: 1,
        pageLimit: 9
      },
      materialName: '',
      materialList: [],
      collegeList: [],
      // 学院列表
      searchInfo: {
        collegeId: '',
        collegeName: '',
        majorId: '0',
        majorName: '',
        awardId: '0',
        awardName: ''
      },
      showMoreCollege: false,
      // 是否显示更多学院
      showMoreMajor: false,
      filterFlag: '',
      majorList: [],
      awardList: []
    };
  },

  watch: {
    searchInfo: {
      handler(value) {
        this.pageInfo.pageIndex = 1;
        this.getMaterialList();
      },

      deep: true
    }
  },
  methods: {
    // 获取教材列表
    async getMaterialList() {
      const params = {
        name: this.materialName || undefined,
        menu_id: this.menuId,
        organ_id: this.searchInfo.collegeId || undefined,
        major_id: this.searchInfo.majorId == '0' ? undefined : this.searchInfo.majorId,
        awards_id: this.searchInfo.awardId == '0' ? undefined : this.searchInfo.awardId,
        '_pageable.size': this.pageInfo.pageLimit,
        '_pageable.page': this.pageInfo.pageIndex - 1
      };
      const res = await this.$http.getMaterialListApi(params);
      this.materialList = res.content;
      this.pageInfo.rows = parseInt(res.totalElements);
    },

    async getMaterialSetting() {
      const params = {
        menu_id: this.menuId,
        business_type: 7
      };
      const res = await this.$http.getMaterialSettingApi(params);
      this.filterFlag = res[0].value_str.replace(/\s+/g, '');

      if (this.filterFlag) {
        this.getOrganList();
        this.getMajorList();
        this.getAwardList();
      }
    },

    // 获取学院
    async getOrganList() {
      const res = await this.$http.getOrganListApi({
        menu_id: this.menuId
      });
      this.collegeList = res.children || [];
      const sum = res.courseNum;
      this.collegeList.unshift({
        id: '',
        organName: '全部',
        courseNum: sum
      });
    },

    // 获取专业
    async getMajorList() {
      const res = await this.$http.getMajorListApi({
        menu_id: this.menuId
      });
      this.majorList = res || [];
    },

    // 获取奖项
    async getAwardList() {
      const res = await this.$http.getAwardListApi({
        menu_id: this.menuId
      });
      this.awardList = res || [];
    },

    handleChangePage(e) {
      // 切换分页
      this.pageInfo.pageIndex = e;
      this.getMaterialList();
    },

    handleChangePageSize(e) {
      this.pageInfo.pageLimit = e;
      this.pageInfo.pageIndex = 1;
      this.searchInfo.collegeId = '';
      this.getMaterialList();
    },

    handleSearch() {
      this.pageInfo.pageIndex = 1;
      this.getMaterialList();
    },

    // 切换学院显示
    toggleShowCollege() {
      this.showMoreCollege = !this.showMoreCollege;
    },

    // 切换学院
    collegeChange(id, college_name) {
      this.searchInfo.collegeId = id;
      this.searchInfo.collegeName = college_name;
    },

    majorChange(id, major_name) {
      this.searchInfo.majorId = id;
      this.searchInfo.majorName = major_name;
    },

    toggleShowMajor() {
      this.showMoreMajor = !this.showMoreMajor;
    },

    awardChange(id, award_name) {
      this.searchInfo.awardId = id;
      this.searchInfo.awardName = award_name;
    },

    toDetail(id) {
      window.location.href = `/materialDetail.html?id=${id}&name=${this.menuInfo.nav_name}&menuId=${this.menuId}`;
    }

  }
};